module.exports = __webpack_public_path__ + "img/1679982847819-IMG_20230328_135022.jpg.e09a3f0d.webp";